/**
 * AuthGuard — wraps protected routes. Redirects to /auth/request if the
 * session is missing. Per AC-012 / AC-016.
 *
 * Uses `<Navigate>` (NEVER `navigate()` in render). The session query is
 * sticky-no-retry, so a 401 resolves cleanly without exponential backoff.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Skeleton } from './components/ui/Skeleton';

export function AuthGuard() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="mx-auto max-w-content w-full px-5 py-12">
        <Skeleton className="h-10 w-1/3 mb-6" />
        <Skeleton className="h-4 w-3/4 mb-2" />
        <Skeleton className="h-4 w-2/3 mb-2" />
      </div>
    );
  }

  if (!isAuthenticated) {
    const returnTo = `${location.pathname}${location.search}`;
    const search = new URLSearchParams({ return_to: returnTo });
    return <Navigate to={`/auth/request?${search.toString()}`} replace />;
  }

  return <Outlet />;
}
